import React from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import MissionCalendar from '../../components/MissionCalendar';
import { useI18n } from '../../i18n/I18nContext';

const GanttChartPage = () => {
  const { t } = useI18n();

  return (
    <DashboardLayout>
      <div className="container-fluid" style={{ padding: '0.5rem' }}>
        <div className="row">
          <div className="col-12">
            <div className="page-header mb-2">
              <h1 className="h4 fw-bold text-dark mb-1">{t('gantt.title')}</h1>
              <p className="text-muted mb-0 small">
                {t('gantt.subtitle')}
              </p>
            </div>

            <div className="modern-card" style={{
              background: '#fff',
              borderRadius: '0.75rem', /* 12px / 16 = 0.75rem */
              boxShadow: '0 0.125rem 0.9375rem rgba(0,0,0,0.08)', /* 2px 15px -> 0.125rem 0.9375rem */
              border: 'none',
              minHeight: '25.0rem' /* 400px / 16 = 25rem */
            }}>
              <div className="card-body p-2">
                <MissionCalendar />
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default GanttChartPage;
